import { createContext, useContext, type ContextType, type FC, type ReactNode } from 'react';

type HeaderFooterServerVarsContext = {
    buyerHost: string;
    isMobile: boolean;
    isTablet?: boolean;
    isMWSearchBarRedesignVariant?: boolean;
    isHeaderFullWidth?: boolean;
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
};

export const HeaderFooterServerVarsContext = createContext<HeaderFooterServerVarsContext>({
    isMobile: false,
    buyerHost: '',
    isMWSearchBarRedesignVariant: false,
    isHeaderFullWidth: false,
    isUserTypeTrade: false,
    isUserTypeVip: false,
});

type HeaderFooterServerVars = ContextType<typeof HeaderFooterServerVarsContext>;

export function useHeaderFooterServerVars(): HeaderFooterServerVars {
    return useContext(HeaderFooterServerVarsContext);
}

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isTablet?: boolean;
    buyerHost: string;
    isMWSearchBarRedesignVariant?: boolean;
    isHeaderFullWidth?: boolean;
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
};

export const HeaderFooterServerVarsContextProvider: FC<Props> = ({
    children,
    buyerHost,
    isMobile,
    isTablet,
    isMWSearchBarRedesignVariant,
    isHeaderFullWidth,
    isUserTypeTrade,
    isUserTypeVip,
}) => (
    <HeaderFooterServerVarsContext
        value={{
            buyerHost,
            isMobile,
            isTablet,
            isMWSearchBarRedesignVariant,
            isHeaderFullWidth,
            isUserTypeTrade,
            isUserTypeVip,
        }}
    >
        {children}
    </HeaderFooterServerVarsContext>
);
